<div class="progress-bar">
    <div class="progress"></div>
    <div class="background" [style.width]="'calc(100% - (' + progress + ' * 100%))'"></div>
</div>
